import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';

const OrderAccepted = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.orderAccepted}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" fill="none"/>
              <path d="M8 12l2 2 4-4" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h1 className={styles.title}>Заказ принят!</h1>
          <p className={styles.message}>
            Ваш заказ успешно оформлен. Наш менеджер свяжется с вами в ближайшее время для подтверждения и завершения заказа.
          </p>
          <button className={styles.homeButton} onClick={handleGoHome}>
            Вернуться на главную
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderAccepted;

